import { render } from "./LicenseChangeField.vue?vue&type=template&id=21b9d6a0"
import script from "./LicenseChangeField.vue?vue&type=script&lang=js"
export * from "./LicenseChangeField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__